import { useRoute, useRouter } from 'vue-router';

import { useRedirectStore } from '@/stores/redirect';
import { useTokenStore } from '@/stores/token';

export function useLogout() {
  const router = useRouter();
  const route = useRoute();
  const tokenStore = useTokenStore();
  const redirectStore = useRedirectStore();

  const logout = (props?: { redirect?: boolean }) => {
    const redirect = props?.redirect;
    const nextPage = !route.path.includes('entralogin') ? route.fullPath : null;
    tokenStore.clearToken();
    if (!!redirect) {
      if (nextPage !== null) {
        redirectStore.set(nextPage);
      }
      void router.push({
        path: '/entralogin',
        query: redirect ? { nextPage } : undefined,
      });
      void router.replace({
        name: 'entralogin',
        query: redirect ? { nextPage } : undefined,
      });
    } else {
      redirectStore.clear();
      void router.push({
        path: '/entralogin',
      });
      void router.replace({
        name: 'entralogin',
      });
    }
  };

  return { logout };
}
